export default "__VITE_ASSET__4gYvz78E__"